module.exports = __webpack_public_path__ + "static/img/sensorVibracao-1.92a996e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/sensorVibracao-1.svg
// module id = 48mF
// module chunks = 0